import { CustomModal } from "../../../../../lib/CustomModal";
import "../styles.scss";
import { FormContainer } from "./FormContainer";

type AbuseModalProps = {
  conversationId: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AbuseModal = ({
  conversationId,
  isOpen,
  setIsOpen,
}: AbuseModalProps) => {
  return (
    <CustomModal
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      width={500}
      titleText="Report Abuse"
      headerClass="abuse-modal__header"
      modalClass="abuse-modal"
      destroyOnClose
    >
      <FormContainer conversationId={conversationId} setIsOpen={setIsOpen} />
    </CustomModal>
  );
};
